/**
 * 自定义tooltip
 * @author lfan
 * @updateTime 2023-05-18
 * @description 使用v-jp-tooltip="内容"指令来给dom元素增加hover提示，会计算当前内容是否超出显示，超出才会提示。
 * @Params v-jp-tooltip:[placement]来控制tooltip显示的位置，默认top。具体参考element-ui中的el-tooltip的placement属性
 * @Params v-jp-tooltip.focus 来控制滑过就显示，即便内容没有超出也会出现提示
 */

import Vue from 'vue';
import Tooltip from './tooltip';

const CommonTooltipConstructor = Vue.extend(Tooltip);

let instance = null;
const tooltipDirective = {};


tooltipDirective.install = Vue => {
  Vue.directive('jpTooltip', {
    bind(el, binding, vNode) {
      el.__tooltipOptoin__ = {content: ''};
      let option = el.__tooltipOptoin__;
      const {
        arg, value, modifiers
      } = binding;
      if (!instance) {
        instance = new CommonTooltipConstructor();
        instance.vm = instance.$mount();
        document.body.appendChild(instance.vm.$el);
        instance.dom = instance.vm.$el;
      }
      // 设置tooltip内容
      option = {content: value};
      if (arg) {
        option.placement = arg;
      }
      el.__tooltipOptoin__ = option;
      // 当前tooltip组件
      const tooltip = instance.$refs.jsRefCommonTooltip;
      // 鼠标滑入
      const mouseEnterHandler = (event) => {
        const cell = event.target;
        const currentOption = el.__tooltipOptoin__;
        if (!currentOption) {
          return false;
        }
        currentOption.content = currentOption.content ? currentOption.content : cell.innerText;
        if (!currentOption.content) {
          return false;
        }
        const range = document.createRange();
        range.setStart(cell, 0);
        range.setEnd(cell, cell.childNodes.length);
        const rangeRect = range.getBoundingClientRect();
        const cellRect = cell.getBoundingClientRect();
        // 配合omitHide自定义指令
        const contentText = el.getAttribute('data-omit-hide-text');
        const isHideOmit = Boolean(contentText && contentText !== cell.innerText);
        if ((modifiers && modifiers.focus) || rangeRect.width > cellRect.width || rangeRect.height / cellRect.height >= 2 || isHideOmit) {
          tooltip.referenceElm = cell;
          tooltip.$refs.popper && (tooltip.$refs.popper.style.display = 'none');
          tooltip.doDestroy();
          tooltip.setExpectedState(true);
          instance.updateContent(currentOption);
          // 打开tooltip
          tooltip.handleShowPopper();
        }
        range.detach();
      };
      // 鼠标划出
      const mouseLeaveHandler = () => {
        if (tooltip) {
          tooltip.setExpectedState(false);
          tooltip.handleClosePopper();
        }
      };
      // 给当前元素绑定个私有变量，方便在unbind中可以解除事件监听
      el.__vueMouseEnter__ = mouseEnterHandler;
      el.__vueMouseLeave__ = mouseLeaveHandler;
      el.addEventListener('mouseenter', mouseEnterHandler);
      el.addEventListener('mouseleave', mouseLeaveHandler);
      // 监听点击事件,隐藏冒泡
      el.addEventListener('mouseup', mouseLeaveHandler);
    },
    update(el, binding, vNode) {
      const {
        arg, value
      } = binding;
      let option = el.__tooltipOptoin__;
      // 设置tooltip内容
      option = {content: value};
      if (arg) {
        option.placement = arg;
      }
      el.__tooltipOptoin__ = option;
      instance.updateContent(option);
    },
    unbind(el, binding) {
      // 解除事件监听
      el.removeEventListener('mouseenter', el.__vueClickOutside__);
      el.removeEventListener('mouseleave', el.__vueMouseLeave__);
      delete el.__vueMouseEnter__;
      delete el.__vueMouseLeave__;
      delete el.__tooltipOptoin__;
    }
  });
};

export default tooltipDirective;
